import { useNavigation } from '@react-navigation/native';
import { useEffect } from 'react';

export default function (headerTitle: string | null) {
    const navigation = useNavigation();
    useEffect(() => {
        if (headerTitle) {
            navigation.setOptions({
                headerTitle,
            });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [headerTitle]);
}
